import { Stack, Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { FunnelImage } from 'core/flow/entities';
import { StarIconStyled, WingImageStyled, WingImageReversedStyled } from './styled';

type SocialReviewMinimalProps = {
  content: {
    image: FunnelImage;
    rating: string;
  };
};

export const SocialReviewMinimal = ({ content }: SocialReviewMinimalProps) => {
  const { image, rating } = content;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
      <WingImageStyled src={image.src} alt={image.alt} width={10} height={24} />
      <StarIconStyled />
      <Typography variant="text-body-xs-bold" dangerouslySetInnerHTML={prepareHtml(rating)} />
      <WingImageReversedStyled src={image.src} alt={image.alt} width={10} height={24} />
    </Stack>
  );
};
